import axios from 'axios'
import { getToken } from '@/utils/auth'
import { urlParamsToObject } from '@/utils/tools'
import { md5 } from '@/utils/md5'
import sendError from '@/utils/sendError'
import { systemConfig } from '@/utils/systemConfig'

const service = axios.create({
  timeout: 10000
})

service.interceptors.request.use(
  (config) => {
    if (getToken()) {
      config.headers.Authorization = `Bearer ${getToken()}`
    }

    let paras = {}
    let appid = ''
    let sign = ''

    try {
      const hosts = JSON.parse(import.meta.env.VITE_API_HOSTS || '[]')
      if (!config.baseURL && hosts?.length > 0) {
        let apiModel = hosts.find((r) => r.path === location.pathname)
        if (!apiModel) {
          let path = location.pathname.substr(1)
          const pathIndex = path.indexOf('/')
          if (pathIndex > 0) path = path.substring(0, pathIndex)
          apiModel =
            hosts.find((r) => r.path === `/${path.toLowerCase()}`) ||
            hosts.find((r) => r.path === '/')
        }
        config.baseURL = apiModel?.host || ''
      }

      if (config.data instanceof FormData) {
        config.baseURL = systemConfig.nasFileHost
        return config
      }

      if (config.url && config.url.indexOf('?') > -1) {
        paras = {
          ...paras,
          ...urlParamsToObject(config.url.substring(config.url.lastIndexOf('?')))
        }
      }

      if (config.data) {
        const urlKeys = Object.keys(paras).map((k) => k.toLocaleLowerCase())
        const dataKeys = Object.keys(config.data).map((k) => k.toLocaleLowerCase())
        dataKeys
          .filter((k) => urlKeys.indexOf(k) > -1)
          .forEach((k) => {
            delete config.data[k]
          })
        paras = { ...paras, ...config.data }
      }

      const txt = JSON.stringify(paras).replace(/\s/g, '')
      paras = JSON.parse(txt)

      const signPara = Object.keys(paras)
        .map((k) => [k.toLocaleLowerCase(), k])
        .filter((k) => k[0] !== 'appid' && k[0] !== 'sign')
        .sort((n, l) => (n[0] > l[0] ? 1 : n[0] === l[0] ? 0 : -1))
        .map((t) => [t[0], paras[t[1]]].join('='))

      const signStr = `${signPara.join('&')}${systemConfig.appSecret}`
      sign = md5(signStr).toLocaleUpperCase()
      appid = systemConfig.appId
    } catch (ex) {
      console.log(ex)
    } finally {
      config.headers.appid = appid
      config.headers.sign = sign
    }

    return config
  },
  (error) => {
    console.log(error)
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  (response) => {
    if (response && response.status === 229) {
      sendError(response.data, 'LimitFlow')
      response.data = { Msg: response.data }
      return response
    }
    if (!response || !response.data) {
      return response
    }
    if (response.data.ErrorCode === 3) {
      window.location.href = '/login'
    } else if (
      response.data.ErrorCode !== 0 &&
      /.*[\u4e00-\u9fa5]+.*/.test(response.data.Msg)
    ) {
      const chineseMsg = [
        '数据验证失败',
        '程序访问异常,请稍后重试！',
        '签名验证失败!',
        '未授权访问,请重新登陆！'
      ]
      const enMsg = [
        'Data verification failed',
        'Program access is abnormal, please try again later!',
        'Signature verification failed!',
        'Unauthorized access, please login again!'
      ]
      const idx = chineseMsg.indexOf(response.data.Msg)
      if (idx >= 0) response.data.Msg = enMsg[idx]
    }
    return response
  },
  (error) => {
    console.log('ERROR', error)
    return Promise.reject(error)
  }
)

export default service
